








































import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import { TsRateeUser } from '@/interfaces'

@Component({
  name: 'UsersRateeCard'
})
export default class UsersRateeCard extends Vue {
  @Prop({ required: true })
  userRatee!: TsRateeUser;

  @Prop({ required: true, default: false })
  hasViewMyScore!: boolean;

  @Emit()
  score () {}
}
